import { EntityQuery } from 'breeze-client';

const baseQuery = EntityQuery.from('OrganisationMemberships');

export const organisationMembershipQueries = {
  selectAll: baseQuery
};
